"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useErrorStyles_exports = {};
__export(useErrorStyles_exports, {
  useErrorStyles: () => useErrorStyles
});
module.exports = __toCommonJS(useErrorStyles_exports);
var import_react = __toESM(require("react"));
var import_react_hook_form = require("react-hook-form");
var import_ServerErrorsContext = require("./ServerErrorsContext");
const useErrorStyles = ({
  name,
  errorClassName,
  errorStyle,
  className,
  style
}) => {
  const {
    formState: { errors },
    setError
  } = (0, import_react_hook_form.useFormContext)();
  const serverError = (0, import_react.useContext)(import_ServerErrorsContext.ServerErrorsContext)[name];
  import_react.default.useEffect(() => {
    if (serverError) {
      setError(name, { type: "server", message: serverError });
    }
  }, [serverError, name, setError]);
  const validationError = name ? (0, import_react_hook_form.get)(errors, name) : void 0;
  if (validationError) {
    if (errorClassName) {
      className = errorClassName;
    }
    if (errorStyle) {
      style = errorStyle;
    }
  }
  return { className, style };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useErrorStyles
});
